import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'mp-app/transition',
    loadComponent: () => import('./pages/transition/transition.component').then((m) => m.TransitionComponent),
    title: '【ダミー】変額保険確認・手続き',
  },
  {
    path: 'mp-app',
    data: { screenId: 'mp0010', showScrollToTop: true },
    loadComponent: () => import('./pages/mp0010/mp0010.component').then((m) => m.Mp0010Component),
    title: '変額保険確認・手続き',
  },
  {
    path: 'mp-app/email-setting',
    data: { screenId: 'mp0011' },
    loadComponent: () => import('./pages/mp0011/mp0011.component').then((m) => m.Mp0011Component),
    title: 'メール通知設定｜変額保険確認・手続き',
  },
  {
    path: 'mp-app/surrender-value',
    data: { screenId: 'mp0012' },
    loadComponent: () => import('./pages/mp0012/mp0012.component').then((m) => m.Mp0012Component),
    title: '現在の解約時清算金｜変額保険確認・手続き',
  },
  {
    path: 'mp-app/financial-results',
    data: { screenId: 'mp0020', showScrollToTop: true },
    loadComponent: () => import('./pages/mp0020/mp0020.component').then((m) => m.Mp0020Component),
    title: '運用状況｜変額保険確認・手続き',
  },
  {
    path: 'mp-app/change-contribution-rate',
    data: { screenId: 'mp0030', showScrollToTop: true },
    loadComponent: () => import('./pages/mp0030/mp0030.component').then((m) => m.Mp0030Component),
    title: '保険料の繰入割合変更｜変額保険確認・手続き',
  },
  {
    path: 'mp-app/change-contribution-rate/confirm',
    data: { screenId: 'mp0031', showScrollToTop: true },
    loadComponent: () => import('./pages/mp0031/mp0031.component').then((m) => m.Mp0031Component),
    title: '保険料の繰入割合変更｜変額保険確認・手続き',
  },
  {
    path: 'mp-app/change-contribution-rate/submit',
    data: { screenId: 'mp0032', showScrollToTop: true },
    loadComponent: () => import('./pages/mp0032/mp0032.component').then((m) => m.Mp0032Component),
    title: '保険料の繰入割合変更｜変額保険確認・手続き',
  },
  {
    path: 'mp-app/change-contribution-rate/finished',
    data: { screenId: 'mp0033' },
    loadComponent: () => import('./pages/mp0033/mp0033.component').then((m) => m.Mp0033Component),
    title: '保険料の繰入割合変更｜変額保険確認・手続き',
  },
  {
    path: 'mp-app/reserve-fund-transfer',
    data: { screenId: 'mp0040', showScrollToTop: true },
    loadComponent: () => import('./pages/mp0040/mp0040.component').then((m) => m.Mp0040Component),
    title: '積立金の移転｜変額保険確認・手続き',
  },
  {
    path: 'mp-app/reserve-fund-transfer/confirm',
    data: { screenId: 'mp0041', showScrollToTop: true },
    loadComponent: () => import('./pages/mp0041/mp0041.component').then((m) => m.Mp0041Component),
    title: '積立金の移転｜変額保険確認・手続き',
  },
  {
    path: 'mp-app/reserve-fund-transfer/submit',
    data: { screenId: 'mp0042', showScrollToTop: true },
    loadComponent: () => import('./pages/mp0042/mp0042.component').then((m) => m.Mp0042Component),
    title: '積立金の移転｜変額保険確認・手続き',
  },
  {
    path: 'mp-app/reserve-fund-transfer/finished',
    data: { screenId: 'mp0043' },
    loadComponent: () => import('./pages/mp0043/mp0043.component').then((m) => m.Mp0043Component),
    title: '積立金の移転｜変額保険確認・手続き',
  },
  {
    path: 'mp-app/error',
    data: { screenId: 'mp9010' },
    loadComponent: () => import('./pages/mp9010/mp9010.component').then((m) => m.Mp9010Component),
    title: '【！】エラー｜変額保険確認・手続き',
  },
  {
    path: 'mp-app/sorry',
    data: { screenId: 'mp9000' },
    loadComponent: () => import('./pages/mp9000/mp9000.component').then((m) => m.Mp9000Component),
    title: 'サービス利用停止中(システムメンテナンス)のお知らせ｜変額保険確認・手続き',
  },
  {
    path: 'mp-app/page-pdf',
    data: { screenId: '000001' },
    loadComponent: () => import('./pages/000001/000001.component').then((m) => m._000001Component),
  },
];
